import $ from 'jquery';
import Region from 'partials/site/header/region/region';
import Cookie from 'modules/cookie/cookie';

export default class {
	constructor(options) {
		const defaults = {
			el: '#headerAsk',
			dom: {
				header: '#header',
				layout: '#layout',
				close: '#headerAskClose',
				open: '#headerAskOpen'
			},
			classes: {
				header: 'b-header_state_ask',
				layout: 'b-layout_state_ask'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$header = $(this.options.dom.header);
		this.cookie = new Cookie();
		return this;
	}

	getDom() {
		this.$layout = $(this.options.dom.layout);
		this.$close = $(this.options.dom.close);
		this.$open = $(this.options.dom.open);
		return this;
	}

	close() {
		this.$header.removeClass(this.options.classes.header);
		this.$layout.removeClass(this.options.classes.layout);
		this.cookie.set('YOTA_CITY_ANSWERED', 1, 365, this.cookie.getDomain());
	}

	open() {
		const self = this;
		self.$header.removeClass(self.options.classes.header);
		self.$layout.removeClass(self.options.classes.layout);
		this.cookie.set('YOTA_CITY_ANSWERED', 1, 365, this.cookie.getDomain());
		setTimeout(function () {
			self.region.open();
		}, 50);
	}

	render() {
		if (this.$header.length && this.$el.length) {
			this.getDom();
			this.region = new Region();
			this.$close.on('click', this.close.bind(this));
			this.$open.on('click', this.open.bind(this));

		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/partials/site/header/ask/ask.js